/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreProjectResponseDto } from '../../models/core-project-response-dto';

export interface ProjectsControllerFindAll$Params {
  tenant: string;
  projectManagerId?: string;
  status?: string;
  contractId?: string;
}

export function projectsControllerFindAll(http: HttpClient, rootUrl: string, params: ProjectsControllerFindAll$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectResponseDto>>> {
  const rb = new CoreRequestBuilder(rootUrl, projectsControllerFindAll.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.query('projectManagerId', params.projectManagerId, {});
    rb.query('status', params.status, {});
    rb.query('contractId', params.contractId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<Array<CoreProjectResponseDto>>;
    })
  );
}

projectsControllerFindAll.PATH = '/o2-core/projects/{tenant}';
